"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SpinGlobal = void 0;
var _react = _interopRequireDefault(require("react"));
var _MonumentLoading = _interopRequireDefault(require("../../images/MonumentLoading.gif"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SpinGlobal = function SpinGlobal(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "fixed inset-0 z-40"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute inset-0 bg-white opacity-50"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute inset-0 flex flex-col items-center p-[20px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[20vh] text-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _MonumentLoading.default,
    width: 50,
    alt: "Loading..."
  }), text && /*#__PURE__*/_react.default.createElement("p", {
    className: "bg-white rounded py-[20px] px-[40px] mt-[40px] tw-subtitle-sm-light",
    style: {
      boxShadow: '0 0 30px 40px #fff'
    }
  }, text))));
};
exports.SpinGlobal = SpinGlobal;
var _default = SpinGlobal;
exports.default = _default;